import { useContext, useEffect, useState } from "react";
import { useLocale, useService } from "../../../../hooks";
import { AppContext } from "../../../../context";
import { brandInfo } from "../../../../constant";

export const useStoreLocator = () => {
  const { t } = useLocale();
  const { fetchByAttr } = useService("Data", "franchise");
  const commonPageSize = 20;
  const { setTitle, setDescription, setKeywords } = useService("Meta");
  const { isBottom } = useService("Misc");
  const appContext = useContext(AppContext);
  const showPreloader = appContext?.actions?.showPreloader || (() => {});
  const hidePreloader = appContext?.actions?.hidePreloader || (() => {});
  const [cities, setcities] = useState([
    {
      label: t("all"),
      value: "all",
    },
  ]);
  const [activeCity, setactiveCity] = useState(cities[0]);
  const [tableData, settableData] = useState([]);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [filteredList, setfilteredList] = useState([]);

  useEffect(() => {
    setTitle(t("storeLocator.meta.title").replace("{brand}", brandInfo.name.capital), "empty");
    setDescription(t("storeLocator.meta.description").replace(/{brand}/g, brandInfo.name.capital));
    setKeywords(t("storeLocator.meta.keywords").replace(/{brand}/g, brandInfo.name.capital));
    getFranchisesData();
    document.addEventListener("scroll", trackScrolling);
    return () => {
      document.removeEventListener("scroll", trackScrolling);
    };
  }, [t]);

  const assignCity = (e) => {
    setactiveCity(e);
    if (e.value === "all") {
      setfilteredList(tableData);
    } else {
      filterItems(e.value, tableData);
    }
  };

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const getFranchisesData = async () => {
    const result = await fetchByAttr({ status: "publish" });
    if (result.status) {
      let tableData = [],
        cities = [
          {
            label: t("all"),
            value: "all",
          },
        ];
      result.data.reverse().forEach((e) => {
        try {
          e.addressDetail = typeof e.addressDetail === "string" ? JSON.parse(e.addressDetail) : e.addressDetail;
          e.owner = typeof e.owner === "string" ? JSON.parse(e.owner) : e.owner;
          e.contactPerson = typeof e.contactPerson === "string" ? JSON.parse(e.contactPerson) : e.contactPerson;
        } catch (error) {
          console.error("Error parsing JSON for franchise", e.id, error);
        }

        if (e.addressDetail && e.addressDetail.address_components) {
          e.addressDetail.address_components.forEach((l) => {
            if (l.types?.includes("administrative_area_level_2")) {
              e.addressDetail.city = l.long_name;
            }
            if (l.types?.includes("sublocality_level_1")) {
              e.addressDetail.area = l.long_name;
            }
          });
        }
        
        e.places = [];
        if (e.addressDetail?.geometry?.location) {
          e.places.push(e.addressDetail.geometry.location);
        }
        
        if (!e.trash) tableData.push(e);
        let cityFound = false;
        cities.forEach((l) => {
          if (e.addressDetail?.city && l.value === e.addressDetail.city) {
            cityFound = true;
          }
        });
        if (!cityFound && e.addressDetail?.city) {
          cities.push({
            label: e.addressDetail.city,
            value: e.addressDetail.city,
          });
        }
      });
      setcities(cities);
      settableData(tableData);
      filterItems("all", tableData);
    }
  };

  const filterItems = (key, tableData) => {
    const filteredList =
      key === "all"
        ? tableData
        : tableData.filter((e) => e.addressDetail?.city === key);
    setfilteredList(filteredList);
  };

  return {
    filteredList,
    activeCity,
    assignCity,
    cities,
  };
};
